import usePopUpAtOnce from 'components/hooks/usePopUpAtOnce';
import { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { updateUI } from 'store/UI/actions';
import { useUI } from 'store/UI/selectors';
import styled from 'styled-components';

const getColorForView = (forView) => {
  switch (forView) {
    case 'units':
      return 'linear-gradient(to right, #f45c43, #ffb347) !important';
    case 'lesson':
      return '#6602b8 !important';
    case 'sub-units':
      return 'linear-gradient(to right, #a855f7, #ec4899) !important';
    default:
      return 'linear-gradient(to right, #f45c43, #ffb347) !important';
  }
};

const EngageButton = ({ hasEngage, forView }) => {
  const { updatePopUpAtOnce } = usePopUpAtOnce();
  const dispatch = useDispatch();
  const UI = useUI();

  const filterEngage = useMemo(() => {
    return hasEngage?.filter((element) => element?.showOptions === forView);
  }, [hasEngage, forView])

  try {
    return (
      <>
        {filterEngage?.map((element, index) => {
          return (
            <div className="w-full flex items-center flex-col cursor-pointer" key={index}>
              <PacingButton
                className={`engageButton ${UI?.openEngageModalTeacher?.id === element?.id && UI?.openEngageModalTeacher && Object.keys(UI?.openEngageModalTeacher)?.length > 0 ? 'active' : ''}`}
                forView={forView}
                style={{
                  width: '100%',
                  textAlign: 'center',
                  color: 'black',
                  borderRadius: 'unset',
                }}
                onClick={() => {
                  if (updatePopUpAtOnce()) return;
                  updatePopUpAtOnce(true);
                  dispatch(
                    updateUI({
                      openEngageModalTeacher: {
                        open: true,
                        id: element?.id,
                        engagePageId: element?.pageId,
                        data: element?.imageData,
                        engageName: element?.sequence,
                      },
                    }),
                  );
                }}
              >
                Engage-{index + 1}
              </PacingButton>
            </div>
          );
        })}
      </>
    );
  } catch (error) {
    console.log(error, 'error in EngageButton');
  }
};

export default EngageButton;

const PacingButton = styled.button`
  background: ${(props) => getColorForView(props.forView)};
  color: white;
  border: none;
  border-radius: 2px;
  padding: 8px;
  margin: 0px 0px 1px 0;
  width: 95px;
  text-align: left;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s ease;
  @media Screen and (max-width: 1200px) {
    text-align: left;
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px ${(props) => {
      const color = props.$forView === 'units' ? 'rgba(255, 179, 71, 0.4)' 
        : props.$forView === 'lesson' ? 'rgba(79, 172, 254, 0.4)'
        : 'rgba(168, 85, 247, 0.4)';
      return color;
    }};
  }
`;
